import { EventTicketBatch } from "../../components/modal-tickets/types/ticket-batch.type";

export type BatchTransitionMode = "date_or_sold_out" | "sold_out_only";

/** The API owns sequence assignment; unsaved lots retain creation order. */
export function hasBatchPredecessor(
  batches: EventTicketBatch[],
  selected?: EventTicketBatch,
): boolean {
  if (selected?.sequence_number != null) return selected.sequence_number > 1;
  if (!selected) return batches.length > 0;
  const index = batches.findIndex(
    (batch) =>
      batch === selected || (selected.id != null && batch.id === selected.id),
  );
  return index > 0;
}

export function batchTransitionDates(
  mode: BatchTransitionMode,
  hasPredecessor: boolean,
  start: string | null,
  end: string | null,
  selected?: EventTicketBatch,
): { sale_start: string | null; sale_end: string | null } {
  if (mode === "date_or_sold_out") return { sale_start: start, sale_end: end };
  const openedStart =
    selected?.transition_mode === "sold_out_only" &&
    selected.sale_start &&
    Date.parse(selected.sale_start) <= Date.now()
      ? selected.sale_start
      : null;
  return { sale_start: hasPredecessor ? openedStart : start, sale_end: null };
}
